import { Box } from "@mui/material";
import { IScannerProps } from "@yudiel/react-qr-scanner";
/**
 * NOTE: We are importing from '/dist/index.cjs.js' because the default
 * ES Module (.mjs) entry point causes a 'BarcodeDetector' import error
 * in our current Webpack/React 17 setup.
 * The TypeScript 'any' type error for this path is resolved by the
 * mapping in tsconfig.json (or the local .d.ts declaration file).
 * Error: ./node_modules/@yudiel/react-qr-scanner/dist/index.esm.mjs, Can't import the named export 'BarcodeDetector' from non EcmaScript module (only default export is available)
 */
import { Scanner as ReactQRScanner, prepareZXingModule, useDevices } from "@yudiel/react-qr-scanner/dist/index.cjs.js";
import { useState } from "react";
import { useTranslate } from "../../../language/i18n";

const ZXING_WASM_URL = `${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/zxing_reader.wasm`;

prepareZXingModule({
  overrides: {
    locateFile: (path: string) => {
      if (path.endsWith(".wasm")) {
        return ZXING_WASM_URL;
      }

      return path;
    },
  },
});

export default function Scanner({ onScan }: { onScan: IScannerProps["onScan"] }) {
  const devices = useDevices();
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>();

  const translate = useTranslate();

  const deviceId = selectedDeviceId;

  return (
    <Box display={"flex"} alignItems={"center"} flexDirection={"column"} marginTop={"2rem"} gap={"2rem"}>
      <Box>
        <Box marginBottom={"2rem"}>
          <select onChange={e => setSelectedDeviceId(e.target.value)} value={deviceId ?? ""}>
            <option value="" disabled>
              {translate("SELECT_A_CAMERA")}
            </option>
            {devices.map(device => (
              <option key={device.deviceId} value={device.deviceId}>
                {device.label || `${translate("CAMERA")} ${device.deviceId}`}
              </option>
            ))}
          </select>
        </Box>
        <Box maxWidth={"50rem"} height={"100%"}>
          <ReactQRScanner
            onScan={onScan}
            constraints={deviceId ? { deviceId } : { facingMode: "environment" }}
            sound={false}
          />
        </Box>
      </Box>
    </Box>
  );
}
